import React, { useState, useEffect, Component } from "react";
import ReactDOM from "react-dom";
import MaterialTable from "@material-table/core";
import Footer from "../../../components/shared/Footer";
import { DocumentTypeRule } from "../../../models";
import AttorneySelect from "../../../components/shared/AttorneySelect";
import { DivisionRulesService } from "../../../services/ClientService";
import DivisionRuleTestModal from "./../../../pages/queue/components/modals/DivisionRuleTestModal";
import { Button } from "react-bootstrap";

export default function DivisionRules() {
    const never = "never" as const;
    const [selectedAttorneyId, setSelectedAttorneyId] = useState("");
    const [selectedFirmId, setSelectedFirmId] = useState("");
    const [ruleModalShow, setRuleModalShow] = useState(false);

    const [data, setData] = useState([] as DocumentTypeRule[]);

    const refreshData = () => {
        if (selectedAttorneyId != "") {
            DivisionRulesService.getList({
                attorneyId: selectedAttorneyId!,
            }).then(
                (resp) => {
                    if (resp.successful && resp.data) {
                        setData(resp.data);
                    } else {
                        //TODO: Show error
                    }
                },
                (error) => {
                    console.log(error);
                }
            );
        }
    };

    useEffect(() => {
        if (selectedAttorneyId != "") {
            DivisionRulesService.getList({
                attorneyId: selectedAttorneyId!,
            }).then(
                (resp) => {
                    if (resp.successful && resp.data) {
                        setData(resp.data);
                    } else {
                        //TODO: Show error
                    }
                },
                (error) => {
                    console.log(error);
                }
            );
        }
    }, [selectedAttorneyId]);

    const onFirmSelected = (id: string, name: string) => {
        setSelectedFirmId(id);
        setSelectedAttorneyId("");
        setData([]);
    };

    const onAttorneySelected = (id: string, name: string) => {
        setSelectedAttorneyId(id);
    };

    return (
        <div className="content">
            <DivisionRuleTestModal
                show={ruleModalShow}
                attorneyId={selectedAttorneyId}
                onSubmit={() => setRuleModalShow(false)}
                onClose={() => setRuleModalShow(false)}
            />
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="page-title-box page-title-box-alt">
                            <h4 className="page-title">Rules</h4>
                            <div className="page-title-right">
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">
                                            eFileMadeEasy
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">Admin</a>
                                    </li>
                                    <li className="breadcrumb-item active">
                                        Rules
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row m-2">
                    <div
                        className="col-sm-8"
                        style={{ maxWidth: "100%", zIndex: 50 }}
                    >
                        <AttorneySelect
                            onAttorneySelected={onAttorneySelected}
                            onFirmSelected={onFirmSelected}
                        />
                    </div>
                    <div className="col-sm-2" style={{ marginTop: "28px" }}>
                        {selectedAttorneyId && (
                            <Button
                                title="Test"
                                type="submit"
                                onClick={() => setRuleModalShow(true)}
                            >
                                Test
                            </Button>
                        )}
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div style={{ maxWidth: "100%", zIndex: 20 }}>
                            <MaterialTable
                                options={{
                                    pageSizeOptions: [5, 10, 20, 50, 75, 100],
                                }}
                                columns={[
                                    {
                                        title: "ID",
                                        field: "id",
                                        editable: never,
                                    },
                                    { title: "County", field: "countyName" },
                                    {
                                        title: "CSV Division",
                                        field: "csvDivision",
                                    },
                                    {
                                        title: "Min Amount",
                                        field: "minAmount",
                                        type: "numeric" as const,
                                    },
                                    {
                                        title: "Max Amount",
                                        field: "maxAmount",
                                        type: "numeric" as const,
                                    },
                                    {
                                        title: "Division",
                                        field: "divisionName",
                                    },
                                    {
                                        title: "Global",
                                        field: "global",
                                        type: "boolean" as const,
                                    },
                                ]}
                                data={data}
                                title="Division Rules"
                                editable={{
                                    onRowAdd: (newData) =>
                                        new Promise((resolve, reject) => {
                                            DivisionRulesService.add({
                                                body: {
                                                    ...newData,
                                                    attorneyID:
                                                        selectedAttorneyId,
                                                    active: true,
                                                },
                                            }).then(
                                                (resp) => {
                                                    refreshData();
                                                    resolve(null);
                                                },
                                                (error) => {
                                                    console.log(error);
                                                    resolve(null);
                                                }
                                            );
                                        }),
                                    onRowUpdate: (newData, oldData) =>
                                        new Promise((resolve, reject) => {
                                            DivisionRulesService.update({
                                                id: oldData?.id ?? "",
                                                body: newData,
                                            }).then(
                                                (resp) => {
                                                    refreshData();
                                                    resolve(null);
                                                },
                                                (error) => {
                                                    console.log(error);
                                                    resolve(null);
                                                }
                                            );
                                        }),
                                    onRowDelete: (oldData) =>
                                        new Promise((resolve, reject) => {
                                            DivisionRulesService.delete({
                                                id: oldData.id ?? "",
                                            }).then(
                                                (resp) => {
                                                    refreshData();
                                                    resolve(null);
                                                },
                                                (error) => {
                                                    console.log(error);
                                                    resolve(null);
                                                }
                                            );
                                        }),
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}
